import { render } from "./RegionDropdown.vue?vue&type=template&id=0c168110&scoped=true"
import script from "./RegionDropdown.vue?vue&type=script&lang=js"
export * from "./RegionDropdown.vue?vue&type=script&lang=js"

import "./RegionDropdown.vue?vue&type=style&index=0&id=0c168110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c168110"]])

export default __exports__